import { useMemo } from 'react';
import { useLoggedInAccount } from '@/features/account-context';

export function useAIAuthHeaders(isLocalHost = false) {
  const user = useLoggedInAccount();

  const headers = useMemo(() => {
    const auth = JSON.stringify({
      storeAlias: user?.store?.alias,
      MainStoreAlias: user?.store?.mainAlias,
      email: user?.store?.email,
      uuid: user?.store?.email,
      role: user?.store?.role,
    });

    return {
      Authorization: isLocalHost ? auth : ``,
    };
  }, [user?.store?.alias]);

  return { user, headers };
}
